var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuickReply(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 20,
    fill: "#222",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5087 0.387085C5.14218 0.387085 0 5.46773 0 11.7097C0 14.7097 1.22433 17.6129 3.37915 19.7419L1.22433 21.871C0.93049 22.1613 0.93049 22.5968 1.22433 22.8871C1.37125 23.0322 1.56714 23.0806 1.76303 23.0806H11.5087C17.8752 23.0806 23.0174 18 23.0174 11.7097C23.0174 5.41934 17.8262 0.387085 11.5087 0.387085ZM16.1611 11.7097L8.96208 18.871C8.86414 19.0161 8.71722 19.0645 8.5703 19.0161C8.42338 19.0161 8.37441 18.9193 8.32543 18.7742C8.32543 18.6774 8.32543 18.629 8.32543 18.5322C8.86414 16.7419 10.1374 12.4355 10.1374 12.4355H7.10111C6.95419 12.4355 6.80727 12.3871 6.70932 12.2419C6.66035 12.0968 6.70932 11.9516 6.85624 11.8548L14.1043 4.69354C14.2022 4.54838 14.3491 4.49999 14.496 4.54838C14.594 4.59676 14.6919 4.69354 14.7409 4.79031C14.7409 4.88708 14.7409 4.93547 14.7409 5.03225C14.3002 6.48386 12.9289 11.129 12.9289 11.129H16.0632C16.2101 11.129 16.406 11.1774 16.455 11.3226C16.406 11.4677 16.3081 11.6129 16.1611 11.7097Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickReply);
export default __webpack_public_path__ + "static/media/quickReply.c6f5f735.svg";
export { ForwardRef as ReactComponent };